import { render, staticRenderFns } from "./ImportControls.vue?vue&type=template&id=00fad4d6&scoped=true"
import script from "./ImportControls.vue?vue&type=script&lang=js"
export * from "./ImportControls.vue?vue&type=script&lang=js"
import style0 from "./ImportControls.vue?vue&type=style&index=0&id=00fad4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fad4d6",
  null
  
)

export default component.exports